import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.0625 0.937502H0.937494C0.812419 0.929983 0.687172 0.949082 0.570022 0.993536C0.452872 1.03799 0.346484 1.10679 0.257883 1.19539C0.169282 1.28399 0.100483 1.39038 0.0560286 1.50753C0.0115742 1.62468 -0.00752423 1.74993 -5.82065e-06 1.875V13.125C-0.00752423 13.2501 0.0115742 13.3753 0.0560286 13.4925C0.100483 13.6096 0.169282 13.716 0.257883 13.8046C0.346484 13.8932 0.452872 13.962 0.570022 14.0065C0.687172 14.0509 0.812419 14.07 0.937494 14.0625H14.0625C14.1876 14.07 14.3128 14.0509 14.43 14.0065C14.5471 13.962 14.6535 13.8932 14.7421 13.8046C14.8307 13.716 14.8995 13.6096 14.944 13.4925C14.9884 13.3753 15.0075 13.2501 15 13.125V1.875C15.0075 1.74993 14.9884 1.62468 14.944 1.50753C14.8995 1.39038 14.8307 1.28399 14.7421 1.19539C14.6535 1.10679 14.5471 1.03799 14.43 0.993536C14.3128 0.949082 14.1876 0.929983 14.0625 0.937502ZM7.49999 10.3125H2.81249V8.4375H7.49999V10.3125ZM12.1875 6.5625H2.81249V4.6875H12.1875V6.5625Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconNote;
